/** @jsxImportSource @emotion/react */
import { TableRowHeader } from "../../../components/table-components/TableRowHeader";
import { TableCellHeaderText } from "../../../components/table-components/TableCellHeaderText";
import { firstTableCellStyle } from "../../../style-util";

export const NewsListHeader = () => {
  return (
    <thead>
      <TableRowHeader>
        <TableCellHeaderText css={firstTableCellStyle}>
          Image
        </TableCellHeaderText>
        <TableCellHeaderText>Title</TableCellHeaderText>
        <TableCellHeaderText>External URL</TableCellHeaderText>
        <TableCellHeaderText>Country code</TableCellHeaderText>
        <th />
      </TableRowHeader>
    </thead>
  );
};
